import rasEmerald96Src from './ras-emerald-96.svg';
import rasSmallSrc from './ras-small.png';
export function Logo(props: React.ComponentPropsWithoutRef<'img'>) {
  return <img src={rasEmerald96Src} width={40} alt="RAS" {...props} />;
}

export function LogoSmall(props: React.ComponentPropsWithoutRef<'img'>) {
  return <img src={rasSmallSrc} width={20} alt="RAS" {...props} />;
}
